import { render, staticRenderFns } from "./lookalike-audience-dialog.vue?vue&type=template&id=6aa2b6f6&"
import script from "./lookalike-audience-dialog.vue?vue&type=script&lang=js&"
export * from "./lookalike-audience-dialog.vue?vue&type=script&lang=js&"
import style0 from "./lookalike-audience-dialog.vue?vue&type=style&index=0&id=6aa2b6f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports